var _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWallet({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 48,
    viewBox: "0 0 70 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 69,
    height: 47,
    rx: 5.5,
    fill: "white",
    stroke: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M36.275 10.57L36.2325 10.6691L32.1242 20.2033H28.0867C27.1234 20.2033 26.2167 20.3875 25.3667 20.7558L27.8459 14.8341L27.9025 14.7066L27.9875 14.48C28.03 14.3808 28.0584 14.2958 28.1009 14.225C29.9567 9.93246 32.0534 8.95496 36.275 10.57Z",
    fill: "#0A49A5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9109 20.487C43.2734 20.3028 42.6076 20.2036 41.9134 20.2036H32.1243L36.2326 10.6695L36.2751 10.5703C36.4734 10.6411 36.6859 10.7403 36.8984 10.8111L40.0293 12.1286C41.7718 12.8511 42.9901 13.602 43.7409 14.5086C43.8684 14.6786 43.9818 14.8345 44.0951 15.0186C44.2226 15.217 44.3218 15.4153 44.3784 15.6278C44.4351 15.7553 44.4776 15.8686 44.5059 15.9961C44.8743 17.2003 44.6476 18.6595 43.9109 20.487Z",
    fill: "#0A49A5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M48.8267 27.1165V29.879C48.8267 30.1623 48.8125 30.4456 48.7983 30.7148C48.5292 35.6731 45.7667 38.1665 40.525 38.1665H29.475C29.1208 38.1665 28.795 38.1381 28.4692 38.0956C23.9642 37.7981 21.5558 35.3898 21.2442 30.8848C21.2017 30.5448 21.1733 30.219 21.1733 29.879V27.1165C21.1733 24.269 22.9017 21.8181 25.3667 20.7556C26.2167 20.3873 27.1233 20.2031 28.0867 20.2031H41.9133C42.6075 20.2031 43.2733 20.3023 43.9108 20.4865C46.7442 21.3506 48.8267 23.9856 48.8267 27.1165Z",
    fill: "#0A49A5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M27.8458 14.834L25.3667 20.7557C22.9017 21.8182 21.1733 24.269 21.1733 27.1165V22.9657C21.1733 18.9423 24.035 15.5848 27.8458 14.834Z",
    fill: "#0A49A5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M48.8267 22.9653V27.1161C48.8267 23.9853 46.7442 21.3503 43.9109 20.4861C44.6476 18.6586 44.8742 17.1995 44.5059 15.9953C44.4776 15.8678 44.4351 15.7545 44.3784 15.627C47.0276 17.0011 48.8267 19.792 48.8267 22.9653Z",
    fill: "#0A49A5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5416 30.7285H31.4583C30.8774 30.7285 30.3958 30.2468 30.3958 29.666C30.3958 29.0852 30.8774 28.6035 31.4583 28.6035H38.5416C39.1224 28.6035 39.6041 29.0852 39.6041 29.666C39.6041 30.2468 39.1224 30.7285 38.5416 30.7285Z",
    fill: "#0A49A5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.7c10a6b923e192e459162f11390592f1.svg";
export { ForwardRef as ReactComponent };